// extracted by mini-css-extract-plugin
export default {"button_language":"language-button_button_language__lRHSQ","button_active":"language-button_button_active__8Mfnb"};